const KeyCodes = {
  LCtrl: -8, LShift: -7, LAlt: -6, LWin: -5,
  RCtrl: -4, RShift: -3, RAlt: -2, RWin: -1,
  RESERVED: 0, ERROR_ROLL_OVER: 1, POST_FAIL: 2, ERROR_UNDEFINED: 3,
  A: 4, B: 5, C: 6, D: 7, E: 8, F: 9, G: 10, H: 11, I: 12, J: 13, K: 14, L: 15, M: 16,
  N: 17, O: 18, P: 19, Q: 20, R: 21, S: 22, T: 23, U: 24, V: 25, W: 26, X: 27, Y: 28, Z: 29,
  '1 !': 30, '2 @': 31, '3 #': 32, '4 $': 33, '5 %': 34,
  '6 ^': 35, '7 &': 36, '8 *': 37, '9 (': 38, '0 )': 39,
  Enter: 40, Esc: 41, Backspace: 42, Tab: 43, Space: 44,
  '- _': 45, '= +': 46, '[ {': 47, '} ]': 48,
  '\\ |': 49, NONE_US: 50, '; :': 51, '\' "': 52,
  '` ~': 53, ', <': 54, '. >': 55, '/ ?': 56,
  Caps: 57, F1: 58, F2: 59, F3: 60, F4: 61, F5: 62, F6: 63, F7: 64, F8: 65, F9: 66, F10: 67, F11: 68, F12: 69,
  Print: 70, ScrLock: 71, Pause: 72, Insert: 73, Home: 74, PgUp: 75, Del: 76, End: 77, PgDn: 78,
  '\u2192': 79, '\u2190': 80, '\u2193': 81, '\u2191': 82, NumLock: 83,
  '/': 84, '*': 85, '-': 86, '+': 87, PadEnter: 88,
  '1 End': 89, '2 \u2193': 90, '3 PgDn': 91, '\u2190 4': 92, '5': 93,
  '6 \u2192': 94, '7 Home': 95, '8 \u2191': 96, '9 PgUp': 97, '0 Ins': 98,
  '.Del': 99, NONUS_BACKSLASH: 100, APPLICATION: 101, POWER: 102, PAD_EQUAL: 103,
  F13: 104, F14: 105, F15: 106, F16: 107, F17: 108, F18: 109, F19: 110, F20: 111,
  F21: 112, F22: 113, F23: 114, F24: 115, EXECUTE: 116, HELP: 117, Menu: 118,
  SELECT: 119,

    VOLUME_UP: 201,VOLUME_DOWN: 202,MUTE: 203,PLAY_PAUSE: 204,STOP: 205,PREV_TRACK:206,NEXT_TRACK:207,CALCULATOR:208,EMAIL:209,EXPLORER:210,
    SEARCH:211,HOME:212,BACK:213,AC_STOP:214,FORWARD:215,REFRESH:216,BOOKMARKS:217,
    CONTROL_PANEL:218,MEDIA_PLAYER:219,BRIGHT_UP:220,BRIGHT_DOWN:221,LAUNCHPAD:222,MISSION_CONTROL_PLUS:223,ASSISTANT:224,VK_PERIOD:225,
    BOOTLOADER:301,REBOOT:302,DISABLE_EX:303,ENABLE_EX:304,INITSET:305,'~ESC':306,'Config1':307,'Config2':308,'Config3':309,'Config4':310,'💡+':311,'💡-':312,
    'Next💡':313,'Prev💡':314,'💡Switch':315,'WinLock':316,'💡Spd+':317,'💡Spd-':318,'5s_Reset':319,'wasd🔁arr': 320,
    '': 1000,FN:401,FN2:402,FN3:403,FN4:404,MouseL:251,MouseR:252,MouseM:253,Mouse4:254,Mouse5:255
};

// 填充KeyStrings对象
const KeyStrings = {};
for (const [key, value] of Object.entries(KeyCodes)) {
  KeyStrings[value] = key;
}

const key_name_replace = [
  [KeyCodes.Esc,KeyCodes.F1,KeyCodes.F2,KeyCodes.F3,KeyCodes.F4,KeyCodes.F5,KeyCodes.F6,KeyCodes.F7,KeyCodes.F8,KeyCodes.F9,KeyCodes.F10,KeyCodes.F11,KeyCodes.F12,KeyCodes.Print,KeyCodes.ScrLock,KeyCodes.Pause,
    KeyCodes['` ~'], KeyCodes['1 !'], KeyCodes['2 @'], KeyCodes['3 #'], KeyCodes['4 $'], KeyCodes['5 %'], KeyCodes['6 ^'], KeyCodes['7 &'], KeyCodes['8 *'], KeyCodes['9 ('], KeyCodes['0 )'], KeyCodes['- _'], KeyCodes['= +'], KeyCodes.Backspace,KeyCodes.Insert,KeyCodes.Home,KeyCodes.PgUp,
    KeyCodes.Tab, KeyCodes.Q, KeyCodes.W, KeyCodes.E, KeyCodes.R, KeyCodes.T, KeyCodes.Y, KeyCodes.U, KeyCodes.I, KeyCodes.O, KeyCodes.P, KeyCodes['[ {'], KeyCodes['} ]'], KeyCodes['\\ |'],KeyCodes.Del,KeyCodes.End,KeyCodes.PgDn,
    KeyCodes.Caps, KeyCodes.A, KeyCodes.S, KeyCodes.D, KeyCodes.F, KeyCodes.G, KeyCodes.H, KeyCodes.J, KeyCodes.K, KeyCodes.L, KeyCodes['; :'], KeyCodes['\' "'], KeyCodes.Enter,
    KeyCodes.LShift, KeyCodes.Z, KeyCodes.X, KeyCodes.C, KeyCodes.V, KeyCodes.B, KeyCodes.N, KeyCodes.M, KeyCodes[', <'], KeyCodes['. >'], KeyCodes['/ ?'], KeyCodes.RShift, KeyCodes['\u2191'],
    KeyCodes.LCtrl, KeyCodes.LWin, KeyCodes.LAlt, KeyCodes.Space,KeyCodes.RAlt, KeyCodes.RWin,KeyCodes.Menu, KeyCodes.RCtrl, KeyCodes['\u2190'], KeyCodes['\u2193'], KeyCodes['\u2192']]
]

const lightingPatternArr = [
  {
    name: '冰蓝常亮',
    value: 1
  },{
    name: '七彩渐变',
    value: 3
  },{
    name: '冰蓝呼吸',
    value: 5
  },{
    name: '三色呼吸',
    value: 12
  },{
    name: 'RGB左右翻滚',
    value: 13
  },{
    name: 'RGB上下翻滚',
    value: 14
  },{
    name: 'RGB聚中变化',
    value: 16
  },{
    name: 'RGB中心旋转',
    value: 18
  },{
    name: 'RGB跑马',
    value: 21
  }, {
    name: '七彩呼吸',
    value: 23
  },{
    name: '星光点点',
    value: 24
  },{
    name: '波光粼粼',
    value: 29
  },{
    name: '钢琴RGB',
    value: 30
  },{
    name: '单色片花',
    value: 32
  },{
    name: 'RGB片花',
    value: 33
  },{
    name: '冰蓝单点亮',
    value: 35
  },{
    name: '单点十字亮',
    value: 39
  },{
    name: '单点全局RGB',
    value: 43
  },{
    name: '单色闪闪',
    value: 50
  }
]

const key_zent75_address = {
  key_map: {
    address: '0x80080160',
    length: 166
  },  // 普通按键映射地址
  key_map_fn: {
    address: '0x80080210',
    length: 166
  },  // fn层按键映射地址
  config_name1: {
    address: '0x80070290',
    length: 64
  }, // 配置1名称地址
  config_name2: {
    address: '0x800702D0',
    length: 64
  }, // 配置2名称地址
  config_name3: {
    address: '0x80070310',
    length: 64
  }, // 配置3名称地址
  config_name4: {
    address: '0x80070350',
    length: 64
  }, // 配置4名称地址
  rgb_enable: {
    address: '0x80080C68',
    length: 1
  },// 灯光开光地址
  rgb_fn_enable: {
    address: '0x80080C6B',
    length: 1
  },// fn灯光开关地址
  win_lock_state: {
    address: '0x80080C70',
    length: 1
  },// win锁灯光开关地址
  cap_enable: {
    address: '0x80080C69',
    length: 1
  },// cap灯光开关地址
  sleep_second_cnt: {
    address: '0x80080C6C',
    length: 4
  },// 休眠时间
  rgb: {
    address: '0x80080B00',
    length: 255
  },// rgb地址
  rgb_solid_enable: {
    address: '0x80080C08',
    length: 85
  },// rgb静动态选项地址
  rgb_config: {
    address: '0x80080C60',
    length: 5
  },// rgbConfig地址
  key_mode: {
    address: '0x800806E0',
    length: 83
  },// 按键模式地址
  press_th: {
    address: '0x800802C0',
    length: 166
  },// 触发值地址
  return_th: {
    address: '0x80080370',
    length: 166
  },// 回弹值地址
  norm_press_th: {
    address: '0x80080580',
    length: 166
  },// 触发高度地址
  norm_return_th: {
    address: '0x80080630',
    length: 166
  },// 回弹高度地址
  press_deadzone: {
    address: '0x80080420',
    length: 166
  },// 顶部死区地址
  return_deadzone: {
    address: '0x800804D0',
    length: 166
  },// 底部死区地址
  keytype_code: {
    address: '0x80070160',
    length: 166
  },// 轴体类别地址
  top_value: {
    address: '0x80070000',
    length: 166
  },// 按键最高处adc地址
  bot_value: {
    address: '0x800700B0',
    length: 166
  },// 按键最低处adc地址
  soft_version: {
    address: '0x80070210',
    length: 4
  },// 固件版本地址
  config_name: {
    address: '0x80070290',
    length: 256
  },// 配置名称地址
  cur_param_num: {
    address: '0x80070218',
    length: 4
  },// 当前配置地址
  key_cancel_code: {
    address: '0x80080a50',
    length: 166
  },// 后覆盖地址
  auto_calib_enable: {
    address: '0x80080c71',
    length: 1
  },// 自动标定
  bind_key_setting: {
    address: '0x80080D00',
    length: 48
  },// 虚拟按键
  bind_key_mode: {
    address: '0x80081DE0',
    length: 83
  },// 虚拟按键模式
}

const colorCodes75_zent = [
  84,83,82,81,80,79,78,77,76,75,74,73,72,71,70,
  55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,
  54,53,52,51,50,49,48,47,46,45,44,43,42,41,40,
  26,27,28,29,30,31,32,33,34,35,36,37,38,39,
  25,24,23,22,21,20,19,18,17,16,15,14,13,12,
  0,1,2,[3,4,5],6,7,8,9,10,11,
]

const key_name75_zent = [
  [KeyCodes.Esc,KeyCodes.F1,KeyCodes.F2,KeyCodes.F3,KeyCodes.F4,KeyCodes.F5,KeyCodes.F6,KeyCodes.F7,KeyCodes.F8,KeyCodes.F9,KeyCodes.F10,KeyCodes.F11,KeyCodes.F12,KeyCodes.Print,KeyCodes.Home,
    KeyCodes['` ~'], KeyCodes['1 !'], KeyCodes['2 @'], KeyCodes['3 #'], KeyCodes['4 $'], KeyCodes['5 %'], KeyCodes['6 ^'], KeyCodes['7 &'], KeyCodes['8 *'], KeyCodes['9 ('], KeyCodes['0 )'], KeyCodes['- _'], KeyCodes['= +'], KeyCodes.Backspace,KeyCodes.Del,
    KeyCodes.Tab, KeyCodes.Q, KeyCodes.W, KeyCodes.E, KeyCodes.R, KeyCodes.T, KeyCodes.Y, KeyCodes.U, KeyCodes.I, KeyCodes.O, KeyCodes.P, KeyCodes['[ {'], KeyCodes['} ]'], KeyCodes['\\ |'],KeyCodes.PgUp,
    KeyCodes.Caps, KeyCodes.A, KeyCodes.S, KeyCodes.D, KeyCodes.F, KeyCodes.G, KeyCodes.H, KeyCodes.J, KeyCodes.K, KeyCodes.L, KeyCodes['; :'], KeyCodes['\' "'], KeyCodes.Enter,KeyCodes.PgDn,
    KeyCodes.LShift, KeyCodes.Z, KeyCodes.X, KeyCodes.C, KeyCodes.V, KeyCodes.B, KeyCodes.N, KeyCodes.M, KeyCodes[', <'], KeyCodes['. >'], KeyCodes['/ ?'], KeyCodes.RShift, KeyCodes['\u2191'],KeyCodes.End,
    KeyCodes.LCtrl, KeyCodes.LWin, KeyCodes.LAlt, KeyCodes.Space, KeyCodes.RAlt, KeyCodes.FN, KeyCodes.RCtrl, KeyCodes['\u2190'], KeyCodes['\u2193'], KeyCodes['\u2192']],
  [
    ...new Array(83).fill(1000)
  ]
];


let statusArr1 = []
for (let i = 0; i < 5; i++) {
  statusArr1.push(new Array(83).fill(false))
}

const key_status75_zent = statusArr1
const key_mode75_zent = new Array(83).fill(1)

const key_body75_zent = new Array(83).fill(0)

const key_press75_zent = new Array(83).fill(0.00)

const key_return75_zent = new Array(83).fill(0.00)

const key_norm_press_th75_zent = new Array(83).fill(0.00)

const key_norm_return_th75_zent = new Array(83).fill(0.00)

const key_press_deadzone75_zent = new Array(83).fill(0.00)

const key_return_deadzone75_zent = new Array(83).fill(0.00)

const key_values75_zent = new Array(83).fill(0)

const key_heights75_zent = new Array(83).fill(0)

const key_direction75_zent = new Array(83).fill('0')

const calibrationStatus75_zent = new Array(83).fill(false)

const max75_zent = new Array(83).fill(0)

const min75_zent = new Array(83).fill(65535)

const key_cover_zent = new Array(83).fill(1000)

const bind_key_mode75_zent = new Array(83).fill(0) // 高级按键模式


export {
  KeyStrings,
  KeyCodes,
  colorCodes75_zent,
  lightingPatternArr,
  key_name75_zent,
  key_name_replace,
  key_zent75_address,
  key_status75_zent,
  key_mode75_zent,
  key_press75_zent,
  key_return75_zent,
  key_norm_press_th75_zent,
  key_norm_return_th75_zent,
  key_press_deadzone75_zent,
  key_return_deadzone75_zent,
  key_body75_zent,
  key_heights75_zent,
  key_values75_zent,
  key_direction75_zent,
  calibrationStatus75_zent,
  max75_zent,
  min75_zent,
  key_cover_zent,
  bind_key_mode75_zent
}
